<template>
    <div class="header_container cKqGNX">
        <div class="header-body">
            <div class="nav-desktop">
                <div class="ant-row">
                    <div class="ant-col ant-col-sm-24 ant-col-md-10 ant-col-lg-6 sm-m-auto">
                        <div class="logo">
                            <a href="/">
                                <img src="../../../assets/images/logo.png" alt="Logo">
<!--                                <span>HOÀNG CÔNG</span>-->
                            </a>
                        </div>
                    </div>
                    <div class="ant-col ant-col-md-14 ant-col-lg-18">
                        <ul>
                            <li class="iMtEnK">
                              <router-link class="frFZp" to="/gioi-thieu">Giới thiệu</router-link>
                            </li>
                            <li class="iMtEnK">
                              <router-link class="frFZp" to="/lien-he">Liên hệ</router-link>
                            </li>
                            <template v-if="!isAuthenticated">
                                <li class="iMtEnK">
                                    <a href="javascript:void(0)" class="frFZp" @click.stop="openModalAuth">Quản lý vé</a>
                                </li>
                                <li class="iMtEnK">
                                    <a href="javascript:void(0)" class="frFZp" @click.stop="openModalAuth">Đăng nhập/Đăng ký</a>
                                </li>
                            </template>
                            <template v-if="isAuthenticated && userData">
                                <li class="iMtEnK">
                                    <router-link :class="'frFZp'" :to="{name: hcRoutes.order}">Quản lý vé</router-link>
                                </li>
                                <li class="iMtEnK">
                                    <div class="dropdown-custom" :class="{open: isOpen}">
                                        <a href="javascript:void(0)" @click.stop="isOpen = !isOpen" class="frFZp mr-3">{{getProp(userData, 'name', 'User')}}</a>
                                        <ul class="dropdown-custom-menu" v-click-outside="closeDropdown">
                                            <li><a href="javascript:void(0)" class="frFZp" @click="logout">Đăng xuất</a></li>
                                        </ul>
                                    </div>
                                </li>
                            </template>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="nav-mobile">
                <div class="topnav">
                    <div class="logo">
                        <a href="/">
                            <img src="../../../assets/images/favicon-hoang-cong.png" alt="Logo">
                            <span>HOÀNG CÔNG</span>
                        </a>
                    </div>
                    <div id="myLinks" v-if="showNav" style="border-top: 1px solid rgba(0,0,0,0.06)">
                        <template v-if="!isAuthenticated">
                            <div class="mt-3">
                                <a href="javascript:void(0)" class="frFZp" @click.stop="openModalAuth">Quản lý vé</a>
                            </div>
                            <div class="mt-2">
                                <a href="javascript:void(0)" class="frFZp" @click.stop="openModalAuth">Đăng nhập/Đăng ký</a>
                            </div>
                        </template>
                        <template v-if="isAuthenticated && userData">
                            <div class="mt-3">
                                <router-link :class="'frFZp'" :to="{name: hcRoutes.order}">Quản lý vé</router-link>
                            </div>
                            <div class="dropdown-custom mt-2" :class="{open: isOpen}">
                                <a href="javascript:void(0)" @click.stop="isOpen = !isOpen" class="frFZp mr-3">{{getProp(userData, 'name', 'User')}}</a>
                                <ul class="dropdown-custom-menu" v-click-outside="closeDropdown">
                                    <li><a href="javascript:void(0)" class="frFZp" @click="logout">Đăng xuất</a></li>
                                </ul>
                            </div>
                        </template>
                    </div>
                    <a href="javascript:void(0);" class="icon" @click.stop="showNav = !showNav">
                        <img src="../../../assets/images/caret-down.svg" style="width: 8px; height: 12px" alt="">
                        <img src="../../../assets/images/bus-icon.svg" style="width: 23px; height: 26px; margin-left: 5px" alt="">
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import {MixinHelper} from "../services";
    import {AUTH_LOGOUT} from "../../../store/actions/Auth";
    import {HCROUTES} from "../constants/Constant";

    export default {
        name: "Header",
        mixins: [MixinHelper],
        data() {
            return {
                showNav: false,
                isOpen: false,
                hcRoutes: HCROUTES
            }
        },
        methods: {
            openModalAuth(event) {
                this.$modalAuth.show();
                event.preventDefault();
            },
            logout() {
                this.$store.dispatch(AUTH_LOGOUT);
                this.closeDropdown();
            },
            closeDropdown() {
                this.isOpen = false;
            }
        },
        computed: {
            ...mapGetters(['isAuthenticated', 'userData'])
        }
    }
</script>

<style scoped>
    .iMtEnK a:hover {
        text-decoration: none;
    }
    .logo a {
        height: 70px;
    }
    .logo a img {
        height: 44px;
        vertical-align: middle
    }
    .logo a span {
        height: 20px;
        position: relative;
        margin-left: 10px;
        color: #333333;
        font-weight: bold;
        font-size: 16px
    }

    .logo a:hover {
        text-decoration: none;
    }
    .cKqGNX {
        display: flex;
        -webkit-box-align: center;
        align-items: center;
        min-height: 60px;
        box-shadow: rgba(0, 0, 0, 0.05) 0px 3px 5px;
    }
    .cKqGNX .header-body {
        width: 1140px;
        margin: 0px auto;
    }
    .cKqGNX .header-body .ant-row {
        display: flex;
        -webkit-box-align: center;
        align-items: center;
    }

    .cKqGNX .header-body .ant-row ul {
        display: flex;
        -webkit-box-pack: end;
        justify-content: flex-end;
        margin-bottom: 0px;
        flex-wrap: wrap;
    }

    .cKqGNX .header-body .ant-row ul li {
        list-style-type: none;
        margin-left: 40px;
    }

    .iMtEnK {
        min-height: 60px;
    }

    .cKqGNX .header-body .ant-row ul li a {
        color: rgb(0, 0, 0);
    }

    .frFZp {
        font-size: 14px;
        line-height: 60px;
        font-weight: bold;
        color: rgba(1, 1, 1, 0.79) !important;
    }

    .topnav {
        /*overflow: hidden;*/
        /*background-color: #333;*/
        position: relative;
    }

    .topnav #myLinks {
        display: block;
    }

    .topnav a {
        color: #000;
        padding: 14px 16px;
        text-decoration: none;
        font-size: 16px;
        display: block;
        font-weight: 600;
    }

    .topnav a.icon {
        /*background: black;*/
        margin-top: 8px;
        display: block;
        position: absolute;
        right: 0;
        top: 0;
    }

    .dropdown-custom {
        position: relative;
    }

    .dropdown-custom-menu {
        position: absolute;
        top: 100%;
        left: 0;
        z-index: 1000;
        display: none;
        float: left;
        min-width: 120px;
        padding: 5px 0;
        margin: 2px 0 0;
        font-size: 14px;
        list-style: none;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid #ccc;
        border: 1px solid rgba(0, 0, 0, .15);
        border-radius: 4px;
        -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, .175);
        box-shadow: 0 6px 12px rgba(0, 0, 0, .175);
    }

    .dropdown-custom .dropdown-custom-menu {
        border-radius: 0;
        border: none;
        top: 100%;
        left: 0;
        border-top: 2px solid #ffcb05;
        transition: all 0.4s ease-out 0s;
        -webkit-transition: all 0.4s ease-out 0s;
        -o-transition: all 0.4s ease-out 0s;
        -ms-transition: all 0.4s ease-out 0s;
        opacity: 0;
        display: block !important;
        transform: translateY(50px);
        -webkit-transform: translateY(50px);
        -o-transform: translateY(50px);
        -ms-transform: translateY(50px);
        -khtml-transform: translateY(50px);
        z-index: 0;
        visibility: hidden;
        margin-top: 0px;
    }

    .dropdown-custom.open .dropdown-custom-menu {
        transform: translateY(0px);
        -webkit-transform: translateY(0px);
        -o-transform: translateY(0px);
        -ms-transform: translateY(0px);
        -khtml-transform: translateY(0px);
        opacity: 1;
        z-index: 1000;
        visibility: inherit;
    }

    .dropdown-custom-menu > li > a {
        display: block;
        padding: 5px 10px;
        clear: both;
        font-weight: 600;
        line-height: 1.42857143;
        color: #333;
        white-space: nowrap;
        border: none;
        margin: 0;
    }
    .dropdown-custom-menu > li {
        margin-left: 0 !important;
    }

    @media (min-width: 992px) {
        .nav-desktop {
            display: block;
        }
        .nav-mobile {
            display: none;
        }
    }

    @media (max-width: 992px) {

        .nav-desktop {
            display: none;
        }
        .nav-mobile {
            display: block;
        }

        .logo {
            margin-left: 36px;
        }
        .frFZp {
            line-height: 0;
        }
        .dropdown-custom-menu {
            margin-left: 10px;
        }
    }

    @media (max-width: 767px) {

        .sm-m-auto {
            margin: auto;
        }
    }

    @media (max-width: 575px) {
        .logo {
            margin-left: 0;
        }
    }

</style>
